module.exports = __webpack_public_path__ + "img/link.f9c23288.svg";